export const projectStatusConstants = [
  { name: "Pending", value: false },
  { name: "Approved", value: true },
];
